import { BroadcastNotificationPayload, StopMethod } from './types';

const NOTIFICATION_TYPE_MAP: Record<BroadcastNotificationPayload['notificationType'], number> = {
    push: 1, popup: 2, list: 3, banner: 4, scroll: 5, box: 6,
};

const STOP_METHOD_MAP: Record<StopMethod, number> = {
    repeat: 1, viewOnce: 2, dontShowAgain: 3,
};

export function buildBroadcastFormData(payload: BroadcastNotificationPayload): FormData {
    const form = new FormData();
    form.append('type', String(NOTIFICATION_TYPE_MAP[payload.notificationType]));

    switch (payload.notificationType) {
        case 'push':
            form.append('title', payload.title);
            form.append('message', payload.message);
            form.append('sendViaEmail', String(payload.sendViaEmail));
            break;
        case 'popup':
            form.append('title', payload.title);
            form.append('message', payload.message);
            form.append('sendViaEmail', String(payload.sendViaEmail));
            form.append('addImage', String(payload.addImage));
            if (payload.image) form.append('image', payload.image);
            form.append('addButton', String(payload.addButton));
            if (payload.addButton) {
                form.append('buttonLabel', payload.buttonLabel);
                form.append('buttonLinkScreen', payload.linkScreen);
                form.append('buttonLinkUrl', payload.buttonUrl)
            }
            break;
        case 'list':
            form.append('title', payload.title);
            form.append('message', payload.message);
            form.append('body', payload.body);
            form.append('sendViaEmail', String(payload.sendViaEmail));
            form.append('addImage', String(payload.addImage));
            if (payload.image) form.append('image', payload.image);
            form.append('addButton', String(payload.addButton));
            if (payload.addButton) {
                form.append('buttonLabel', payload.buttonLabel);
                form.append('buttonLinkScreen', payload.linkScreen);
                form.append('buttonLinkUrl', payload.buttonUrl)
            }
            break;
        case 'banner':
            form.append('turnOnOff', String(payload.turnOn));
            form.append('addImage', String(!!payload.image));
            if (payload.image) form.append('image', payload.image);
            // AddButtonSection in BannerNotificationForm is labeled "Banner Linking"
            form.append('bannerLinking', String(payload.addButton));
            if (payload.addButton) form.append('linkingScreen', payload.linkScreen);
            if (payload.stopMethod) form.append('stopMethod', String(STOP_METHOD_MAP[payload.stopMethod]));
            break;
        case 'scroll':
            form.append('turnOnOff', String(payload.turnOn));
            form.append('message', payload.message);
            break;
        case 'box':
            form.append('turnOnOff', String(payload.turnOn));
            form.append('title', payload.title);
            form.append('message', payload.message);
            break;
    }

    return form;
}
